/**
 * Builder.io Configuration
 * 
 * Lazy-loads Builder SDK only when enabled to preserve bundle size.
 * Tree-shakeable when VITE_BUILDER_ENABLED=false.
 */

let builderInstance: any = null;
let builderInitialized = false;

export const isBuilderEnabled = (): boolean => {
  return import.meta.env.VITE_BUILDER_ENABLED !== 'false';
};

export const getBuilder = async (): Promise<any | null> => {
  if (!isBuilderEnabled()) {
    return null;
  }

  const apiKey = import.meta.env.VITE_BUILDER_API_KEY;
  if (!apiKey) {
    if (import.meta.env.DEV) {
      console.warn('[Builder] VITE_BUILDER_API_KEY not set');
    }
    return null;
  }

  if (builderInitialized && builderInstance) {
    return builderInstance;
  }

  try {
    // Lazy import to keep Builder out of bundle when disabled
    const { builder } = await import('@builder.io/react');
    
    if (!builderInstance) {
      builder.init(apiKey, {
        // Add API host if needed (defaults to cdn.builder.io)
        // apiHost: 'https://cdn.builder.io',
      });
      builderInstance = builder;
      builderInitialized = true;

      // Dev banner (once)
      if (import.meta.env.DEV && !(window as any).__builder_banner_shown) {
        console.log(`[Builder] Enabled for path: ${window.location.pathname}`);
        (window as any).__builder_banner_shown = true;
      }
    }

    return builderInstance;
  } catch (error) {
    // Silently fail - Builder is optional, app should work without it
    if (import.meta.env.DEV) {
      console.warn('[Builder] Failed to initialize (non-blocking):', error);
    }
    return null;
  }
};

